/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ModalAcessibilidadeAliases {
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LAYOUT_3 = 'layout-3',
  LAYOUT_4 = 'layout-4',
  LINK_0 = 'link-0',
  LINK_MODELO_ACESSIBILIDADE = 'link-modelo-acessibilidade',
  LINK_RESOLUCAO = 'link-resolucao',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_4 = 'panel-4',
  PANEL_5 = 'panel-5',
  PANEL_ACESSIBILIDADE = 'panel-acessibilidade',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_7 = 'text-7',
}
export { ModalAcessibilidadeAliases };
